<template>
  <div class="essentialInfo">
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <div class="essentialInfo-jb">
        <div class="hearde">基本信息</div>
        <div class="head-sculpture"></div>
        <!-- 。。。。。。。。。 -->
        <div class="society">
          <el-form-item label="头像">
            <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
              :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="职业">
            <span style=" padding-left: 9px;color: #bbbbbb;">{{ userinfo.userTypeId == 1 ? '项目申报人' : '其他' }}</span>
          </el-form-item>
          <!-- 基本信息表单 -->
          <el-form-item label="姓名" style="width: 740px" prop="realname">
            <el-input v-model="reference.realname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" style="width: 400px;position: relative;" prop="phone">
            <el-input :disabled="true" v-model="reference.phone" placeholder="请输入联系方式"></el-input>
            <div class="modifications">
              <el-button @click="$router.push('/changePhone')" type="info">修改</el-button>
            </div>
          </el-form-item>
          <el-form-item label="邮箱" style="width: 740px" prop="email">
            <el-input v-model="reference.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="essentialInfo-qt">
        <div class="hearde">其他信息</div>
        <div class="other">
          <!-- 其他信息表单 -->
          <el-form-item label="备注">
            <el-input type="textarea" v-model="reference.remarks" placeholder="请输入备注"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </div>
      <!-- 最外侧 -->
    </el-form>
  </div>
</template> 
<script>
import { filteringInformation } from ".././../../utils/filtering";
export default {
  name: 'essentialInfo',
  data() {
    return {
      userinfo: {},
      reference: {
        json: {},
        avatar: '', //头像 //require('../../../assets/image/avater.png')
        email: '',//邮箱
        remarks: '', //备注 
        userTypeId: '', //用户身份id
        phone: '',//联系方式
        realname: '',//名称  realname
      },
      rules: {
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
      },
      imageUrl: '',
      action: `https://laravel.gongshicloud.com/api/index/upload`,
    };
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"))
    this.reference = filteringInformation(this.userinfo, this.reference)
    this.imageUrl = this.reference.avatar
  },
  methods: {
    //log上传 
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.avatar = res.data.url
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAPI()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交接口
    async submitAPI() {
      const { data: data } = await this.$http.post("user/changeInfo", this.reference)
      this.reference = data.data
      location.reload()
      this.$message({
        message: data.message,
        type: 'success'
      });
      // this.$router.push('/home')
      // location.reload()
    }
  },

}

</script>
<style lang="less" scoped>
.essentialInfo {
  .hearde {
    font-size: 16px;
    color: #212529;
    font-weight: 600;
    padding-bottom: 35px;
  }

  .commonality {
    font-size: 16px;
    color: #212529;
    margin-bottom: 12px;

    .commonality-sign {
      color: #ff0000;
      padding-right: 5px;
      font-weight: 600;
    }
  }

  .essentialInfo-jb {
    padding: 20px;
    margin-top: 23px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;

    .society {

      // padding-top: 25px;
      .measurement {
        text-align: center;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .head-sculpture {
      .head-sculpture-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        margin-left: 3px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    // & /deep/ .el-form-item__label {
    //   font-size: 16px;
    //   color: #212529;
    //   padding-bottom: 15px;
    //   line-height: 16px;
    //   &::before {
    //     content: "*";
    //     color: #ff0000;
    //     padding-right: 5px;
    //     font-weight: 600;
    //   }
    // }
  }

  .essentialInfo-qt {
    padding: 20px;
    margin-top: 40px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;

    // .other {
    // }
    & /deep/ .el-form-item__label {
      font-size: 16px;
      color: #212529;
      padding-bottom: 15px;
      line-height: 16px;
    }

    // 上传图片
    & /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
    }

    .uploads {
      display: flex;

      .upload-demo {
        display: flex;

        // align-items: center;
        .el-button {
          border-radius: 6px 0 0 6px;
        }

        /deep/ .el-upload-list {
          border: 1px solid #f0f0f0;
          border-radius: 0 6px 6px 0;
          width: 421px;
          height: 32px;
          margin-top: 5px;

          .el-upload-list__item {
            margin: 3px 0;
          }
        }
      }

      .ticks {
        color: #cc0808;
        font-size: 12px;
        margin-top: 5px;
        margin-left: 13px;
      }
    }
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  .modifications {
    position: absolute;
    top: 0;
    left: 420px;
  }
}
</style>